import React from 'react';
import Container from '@amzn/awsui-components-console/container';
import SpaceBetween from '@amzn/awsui-components-console/space-between';
import Box from '@amzn/awsui-components-console/box';
import Table from '@amzn/awsui-components-console/table';
import { ROADMAP_ITEMS, RoadmapItem } from '../../constants';
import { useTranslation } from 'src/i18n/shim/useTranslation';
import styles from './Roadmap.module.scss';

const Roadmap: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section
      aria-label={t('landing-roadmap-section-aria')}
      className={styles.section}
      id="roadmap"
    >
      <Container>
        <SpaceBetween size="l">
          <Box textAlign="center">
            <SpaceBetween size="xs">
              <Box
                variant="h2"
                fontSize="heading-xl"
                fontWeight="bold"
                textAlign="center"
              >
                {t('landing-roadmap-heading')}
              </Box>
              <Box variant="p" color="text-body-secondary" textAlign="center">
                {t('landing-roadmap-body')}
              </Box>
            </SpaceBetween>
          </Box>
          <div className={styles.tableWrapper}>
            <Table<RoadmapItem>
              variant="borderless"
              // Keyed on the resource id rather than the rendered milestone name, which now varies
              // by locale.
              trackBy="milestoneId"
              columnDefinitions={[
                {
                  id: 'milestone',
                  header: (
                    <Box fontWeight="bold">
                      {t('landing-roadmap-col-milestone')}
                    </Box>
                  ),
                  width: 180,
                  minWidth: 140,
                  cell: (item) => (
                    <Box fontWeight="bold">{t(item.milestoneId)}</Box>
                  ),
                },
                {
                  id: 'capabilities',
                  header: (
                    <Box fontWeight="bold">
                      {t('landing-roadmap-col-capabilities')}
                    </Box>
                  ),
                  cell: (item) => <Box>{t(item.capabilitiesId)}</Box>,
                },
                {
                  id: 'target',
                  header: (
                    <Box fontWeight="bold">
                      {t('landing-roadmap-col-target')}
                    </Box>
                  ),
                  width: 140,
                  minWidth: 110,
                  cell: (item) => (
                    <Box color="text-status-info">{t(item.targetId)}</Box>
                  ),
                },
              ]}
              items={ROADMAP_ITEMS}
              footer={
                <div className={styles.footerWrapper}>
                  <Box
                    textAlign="center"
                    color="text-body-secondary"
                    padding="m"
                  >
                    {t('landing-roadmap-footer')}
                  </Box>
                </div>
              }
            />
          </div>
        </SpaceBetween>
      </Container>
    </section>
  );
};

export default Roadmap;
